import { makeStyles } from "@material-ui/core/styles"

export const useCalendarToolStyle = makeStyles({
    root: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",
    },
    timePicker: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",
    },
})
